var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-rtc-container",attrs:{"id":"player-rtc-container"}},[_c('comp-stream-player',{ref:"streamPlayer",staticClass:"stream-player"}),_c('div',{staticClass:"control-container",on:{"click":_vm.handlePause}},[_c('comp-play',{nativeOn:{"click":function($event){return _vm.handlePlay.apply(null, arguments)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }